import { RSAA } from 'redux-api-middleware';

import {
  CREATE_TOKEN_REQUESTED,
  CREATE_TOKEN_SUCCESS,
  CREATE_TOKEN_FAILURE,
  GET_TOKENS_REQUESTED,
  GET_TOKENS_FAILURE,
  GET_TOKENS_SUCCESS,
  DELETE_TOKEN_REQUESTED,
  DELETE_TOKEN_FAILURE,
  DELETE_TOKEN_SUCCESS,
} from '../actions';

const createTokenActionSet = (data) => ({
  [RSAA]: {
    types: [
      CREATE_TOKEN_REQUESTED,
      {
        type: CREATE_TOKEN_SUCCESS,
        meta: { analytics: true },
      },
      CREATE_TOKEN_FAILURE,
    ],
    method: 'POST',
    endpoint: '/apitokens/',
    body: JSON.stringify(data),
  },
});

/**
 * Creates an api token based on the provided details
 *
 * @param  {object} details - The details of the token
 */
export const createToken = (details) => (dispatch) => dispatch(createTokenActionSet(details));

const getTokensActionSet = () => ({
  [RSAA]: {
    types: [GET_TOKENS_REQUESTED, GET_TOKENS_SUCCESS, GET_TOKENS_FAILURE],
    method: 'GET',
    endpoint: '/apitokens/',
  },
});

/**
 * Retrieves a list of api tokens
 */
export const getTokens = () => (dispatch) => dispatch(getTokensActionSet());

const deleteTokenActionSet = (id) => ({
  [RSAA]: {
    types: [
      DELETE_TOKEN_REQUESTED,
      {
        type: DELETE_TOKEN_SUCCESS,
        meta: { analytics: true, id },
      },
      DELETE_TOKEN_FAILURE,
    ],
    method: 'DELETE',
    endpoint: `/apitokens/${id}/`,
  },
});

/**
 * Deletes an api token
 *
 * @param  {object} id - id of token to delete
 */
export const deleteToken = (id) => (dispatch) => dispatch(deleteTokenActionSet(id));
